var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.88 71.81a25.73 25.73 0 1 0-25.73-25.73 25.76 25.76 0 0 0 25.73 25.73m0-44.46a18.73 18.73 0 1 1-18.73 18.73 18.75 18.75 0 0 1 18.73-18.73M67.88 86a37 37 0 0 1 36 28.79 3.52 3.52 0 0 0 3.42 2.79 3.5 3.5 0 0 0 3.42-4.24 43.9 43.9 0 0 0-85.69 0 3.51 3.51 0 0 0 3.43 4.24 3.51 3.51 0 0 0 3.41-2.79A37 37 0 0 1 67.88 86",
    className: "user_svg__cls-1"
  })));
};
export default SvgUser;